import React, { Fragment, useState, useEffect, useRef } from 'react';
import I18n from 'lib/i18n/i18n';
import { CARAT_WEIGHT_SUGGESTION_MAX_VALUE } from '../../constans/index';
import { isMobile } from '../../helpers/ApplicationHelper';
import { animateScroll } from 'react-scroll';

const LabeledField = (props) => {
  const [value, setValue] = useState(props.value || '');
  const [suggestions, setSuggestions] = useState([]);
  const inputField = useRef(null);
  
  const noneZero =
    props.label ===
      I18n.getString('submitForm::necklace::fields::numberOfDiamonds::label') ||
    props.label ===
      I18n.getString('submitForm::necklace::fields::totalCaratWeight::label') ||
    props.label ===
      I18n.getString('submitForm::necklace::fields::caratWeight::label');

  const withSuggestions =
    props.label ===
      I18n.getString('submitForm::necklace::fields::totalCaratWeight::label') ||
    props.label ===
      I18n.getString('submitForm::necklace::fields::caratWeight::label');

  const onChange = (event) => {
    let newValue = '';
    if (event.target.value.length) {
      newValue =
        event.target.value.charAt(0).toUpperCase() +
        event.target.value.slice(1);
    }
    if (newValue !== value) {
      setValue(newValue);
    }
  };

  const validator = (event) => {
    if (noneZero && parseFloat(event.target.value) <= 0 ) {
      return false
    } else if (withSuggestions && parseFloat(event.target.value) > 10) {
      return false
    } else {
      return true
    }
  }

  const onKeyPress = (event) => {  
    if (event.key === 'Enter') {
      if (validator(event)) {
        props.updateValue(value);
      } else {
        null;
      }    
    }
  };

  const blur = (event) => {
    if (validator(event)) {
      props.updateValue(value);
    } else {
      null;
    }
  };

  const checkSuggestions = (val) => {
    if (val <= 10 || !withSuggestions) {
      setSuggestions([]);
      return false;
    } else {
      let newSuggestions = [];

      for (
        let divisor = 1;
        newSuggestions.length < 3 && val / divisor >= 0.1;
        divisor *= 10
      ) {
        if (val / divisor <= CARAT_WEIGHT_SUGGESTION_MAX_VALUE) {
          const strCheckVal = (val / divisor + Number.EPSILON).toString(),
            decimalPointIdx = strCheckVal.indexOf('.'),
            decimalDigitsCount =
              decimalPointIdx !== -1
                ? strCheckVal.length - decimalPointIdx - 1
                : 0;
          newSuggestions.unshift(
            parseFloat(
              strCheckVal.substr(0, strCheckVal.length - decimalDigitsCount + 2)
            )
          );
        }
      }
      setSuggestions(newSuggestions);
      setTimeout(() => {
        props.setFullHeight();
      }, 0);
    }
  };



  useEffect(() => {
    // on mobile devices - scroll to the input field after selecting other.
    if (isMobile()) {
      setTimeout(() => {
        // if we unmounted it is no longer valid. verify.
        if (inputField) {
          animateScroll.scrollTo(inputField.offsetTop - 150, {
            duration: 300,
          }); // -150 for a gentler experience.
        }
      }, 200);
    }

    // focus the input field after the animation ends.
    setTimeout(() => {
      inputField ? inputField.current.autoFocus = true : null;
    }, 800);
  }, []);


  return (
    <Fragment>
      <div
        className={`labeled-field ${
          suggestions.length ? 'open-suggestions' : ''
        }`}
      >
        {props.fieldLabel ? (
          <div className={'labeled-field-label'}>{props.fieldLabel + ':'}</div>
        ) : null}
        <div className={'labeled-field-input-wrapper'}>
          <input
            type={`${props.inputType || 'text'}`}
            className={'labeled-field-input'}
            placeholder={props.placeholder || ''}
            onChange={(e) => {
              onChange(e);
              checkSuggestions(e.target.value);
            }}
            onKeyPress={onKeyPress}
            onBlur={e => {blur(e)}}
            value={value}
            autoFocus
            ref={inputField}
          />
        </div>
        {suggestions.length ? (
          <div id='suggestions-wrapper'>
            {suggestions.map((suggestion, idx) => {
              return (
                <div
                  className='suggestion-wrapper'
                  key={idx}
                  data-value={suggestion}
                  onClick={() => {
                    props.updateValue(suggestion.toString());
                    setSuggestions([]);
                  }}
                >
                  <span className='suggestion'>{suggestion + 'CT'}</span>
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    </Fragment>
  );
};

export { LabeledField };
